import type { Event } from '@unifyapps/defs/types/event';
import { EventTypeEnum } from '@unifyapps/defs/types/event';
import type { NavItemConfig } from '@unifyapps/defs/types/interface';
import { MenuItem } from '@unifyapps/ui/components/Menu';
import { useCallback } from 'react';
import useBlockEvents from '../no-code/hooks/useBlockEvents';

export const ButtonMenuItem = ({
  item,
  index,
  enableKeyboardNavigation = true,
  className,
  onMouseEnter,
  events,
}: {
  item: NavItemConfig;
  index: number;
  enableKeyboardNavigation: boolean;
  className: string;
  onMouseEnter: (index: number) => void;
  events?: Event[];
}) => {
  const { emitEvent } = useBlockEvents(events);

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      emitEvent({
        eventType: EventTypeEnum.OnClick,
      });
    },
    [emitEvent],
  );

  const handleMouseEnter = useCallback(() => {
    onMouseEnter(index);
  }, [index, onMouseEnter]);

  return (
    <MenuItem
      className={className}
      enableHoverEffect={!enableKeyboardNavigation}
      index={index}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      selected={item.selected}
      startDecoratorNode={item.startDecoratorNode}
      title={item.title}
      titleClassName={item.titleClassName}
    />
  );
};
